<template>
  <button class="button" :class="className" @click="onClick($event)">
    <span class="material-symbols-outlined" :style="`font-size: ${size}px`">
      {{iconName}}
    </span>
  </button>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      required: true
    },
    size: Number,
    className: String,
    onClick: Function
  }
}
</script>

<style scoped>
.button {
  background: transparent;
  border: none;
  padding: 0;

  span {
    display: block;
  }
}
</style>
